import { Box, Stack, Typography } from "@mui/material";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";

export default function ComingSoon({ title }: { title?: string }) {
  return (
    <Box sx={{ p: 3, height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Stack alignItems="center" spacing={1.5} sx={{ color: "text.secondary", textAlign: "center" }}>
        <ConstructionOutlinedIcon sx={{ fontSize: 56, opacity: 0.4 }} />
        {title && (
          <Typography variant="h5" sx={{ fontWeight: 700, color: "text.primary" }}>{title}</Typography>
        )}
        <Typography variant="h6" sx={{ fontWeight: 600 }}>Próximamente</Typography>
        <Typography variant="body2">Esta sección todavía no está disponible.</Typography>
      </Stack>
    </Box>
  );
}
